import React from "react";
import { FiSettings, FiTrendingUp, FiSmartphone, FiZap, FiLayers, FiUsers, FiCode, FiShield, FiShoppingCart } from "react-icons/fi";
import { FaWordpress } from "react-icons/fa6";
import {
  LuSettings,
  LuUsers,
  LuSmartphone,
  LuShieldCheck,
  LuPercent,
  LuShield,
  LuBuilding2,
  LuShoppingBag,
  LuClock,
  LuWallet,
  LuCpu,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

// 1. Hero Block Configuration
export const wordpressDevelopmentHeroData = {
  backgroundImage: "/images/serviceBanners/WordpressBanner.webp",
  whiteImage: "/images/serviceBanners/wordpressBanW.webp",
  subTitle: "High-Performance WordPress Websites",
  title: (
    <>
      Design & Build with <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">WordPress Development</span> <br /> Solutions
    </>
  ),
  description:
    "WordPress websites built for speed, scalability, and performance that deliver seamless user experiences, improve site functionality, and support business growth through flexible and optimized content management solutions.",
  primaryButton: {
    title: "Start Your Project",
    onClick: () => console.log("WordPress Start clicked"),
  },
  secondaryButton: {
    title: "View Our Portfolio",
    onClick: () => console.log("View Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast WordPress sites with better speed.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Works perfectly on all devices.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Strong security and stable performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Simple, maintainable WordPress code.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(33,117,155,0.35)", // WordPress Blue glow
      iconGlow: "rgba(33,117,155,0.9)",
    },
  ],
};

// 2. Stats Block
export const wordpressStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const wordpressSolutionsAndProcessData = {
  buildSubtitle: "OUR WP EXPERTISE",
  buildTitle: "Custom WordPress Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform WordPress Solutions",
      desc: "Build fast and scalable websites across devices.",
      icon: FiLayers,
      colorClass: "text-[#21759b]",
      bgClass: "bg-[#21759b]/10",
      borderClass: "border-[#21759b]/20 hover:border-[#21759b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(33,117,155,0.25)]",
    },
    {
      title: "Enterprise WordPress Development",
      desc: "Secure and scalable websites for large businesses.",
      icon: FiShoppingCart,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce WordPress Development",
      desc: "Feature-rich online stores with smooth shopping experience.",
      icon: FiCode,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand WordPress Solutions",
      desc: "Flexible websites for booking and service systems.",
      icon: FiShield,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Secure WordPress Development",
      desc: "Strong security with stable website performance.",
      icon: FiShield,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom WordPress Solutions",
      desc: "Tailored WordPress development based on business needs.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR DELIVERY PROCESS",
  processTitle: "WordPress Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand business goals, target audience, and website requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define site structure, features, and development roadmap.",
      icon: LuPalette,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create modern, user-friendly and conversion-focused layouts.",
      icon: LuCode,
    },
    {
      step: "04",
      title: "Development",
      description: "Build fast, scalable and SEO-friendly WordPress websites.",
      icon: LuRocket,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Check performance, security, and responsiveness.",
      icon: LuPalette,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch website and provide ongoing maintenance and updates.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR WORDPRESS DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose WordPress Development Solutions",
  benefits: [
    "Cross-platform support",
    "Faster development speed",
    "Modern UI design",
    "Smooth performance boost",
    "Efficient workflow process",
    "Scalable solutions architecture",
    "Cost-effective development model",
  ],
  logoImage: "/images/serviceBanners/WordpressBanner.webp",
  whiteLogoImage: "/images/serviceBanners/wordpressBanW.webp",
};
// 4. Portfolio Data
export const wordpressPortfolioData = {
  subtitle: "OUR SUCCESS STORIES",
  title: "WordPress Sites Powering Industries",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "Global Tech Portal",
      badge: "Enterprise CMS",
      badgeColor: "bg-[#21759b]/10 text-[#21759b] border-[#21759b]/20",
      desc: "A high-traffic news portal with complex taxonomy and multi-author workflow.",
      downloads: "1M+ Visitors",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1515168833906-d2a3b82b3029?auto=format&fit=crop&w=800&q=80",
    },
  ],
};

// 5. Technologies Data
export const wordpressTechnologiesData = {
  techTitle: "WORDPRESS ECOSYSTEM",
  technologies: [
    { name: "WordPress Core", icon: "RestAPI" },
    { name: "PHP / MySQL", icon: "SQLite" },
    { name: "Gutenberg", icon: "Layout" },
    { name: "WP-CLI", icon: "CLI" },
    { name: "Elementor/Divi", icon: "Palette" },
    { name: "REST API", icon: "RestAPI" },
  ],
  trustTitle: "TRUSTED BY CORPORATE BRANDS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview
export const wordpressAboutData = [
  {
    title: "WordPress Development Services for Scalable Digital Growth",
    content: (
      <>
        A business website should do more than simply exist online. Effective <b className="text-text-primary font-semibold">wordpress development services</b> help businesses
        create fast, flexible, and user-focused websites designed to support growth and improve customer experiences. Many businesses face issues with outdated structures, slow
        performance, or websites that fail to convert visitors into leads. At <b className="text-text-primary font-semibold">Tycho Technologies</b>, WordPress solutions are
        developed around business objectives, usability, and long-term scalability to help brands strength their online presence with confidence.
      </>
    ),
  },
  {
    title: "WordPress Website Development Company for Better User Experience",
    content: (
      <>
        Customers expect websites that are easy to navigate, visually clear, and simple to interact with across devices. A reliable{" "}
        <b className="text-text-primary font-semibold">wordpress website development company</b> helps businesses improve digital experiences through customized functionality and
        structured website planning. Companies investing in <b className="text-text-primary font-semibold">custom wordpress development</b> often gain stronger flexibility because
        websites can be built around unique workflows and business requirements. Tycho Technologies focuses on practical development strategies that support performance, usability,
        and long-term business success.
      </>
    ),
  },
  {
    title: "WordPress Plugin Development Services for Greater Flexibility",
    content: (
      <>
        Growing businesses often require website functionality that goes beyond standard templates and built-in features. Reliable{" "}
        <b className="text-text-primary font-semibold">wordpress plugin development services</b> help organizations improve website capabilities, streamline operations, and create
        more personalized digital experiences. Businesses looking to strengthen online selling capabilities often combine website improvements with{" "}
        <b className="text-text-primary font-semibold">wordpress ecommerce development</b> to support smoother customer journeys and stronger digital commerce performance.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a WordPress Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">wordpress development company in india</b> continues to grow as businesses seek flexible and
        scalable website solutions. Companies working with <b className="text-text-primary font-semibold">wordpress developers india</b> often prioritize better customization,
        long-term usability, and stronger website performance. Businesses partnering with Tycho Technologies benefit from tailored WordPress frameworks designed around measurable
        business goals. Many organizations also strengthen digital growth strategies by working with a trusted{" "}
        <a href="https://tychotechnologies.com/shopify-development-india" className="text-cyan-400 underline hover:text-cyan-300">
          shopify website development company
        </a>{" "}
        to expand eCommerce opportunities across platforms.
      </>
    ),
  },
];

// 7. FAQs (Preserved)
export const wordpressDevelopmentFaqs = [
  {
    q: "Why should I choose WordPress development for my website?",
    a: "WordPress allows businesses to create flexible, user-friendly, and highly customizable websites with easy content management and SEO-friendly features.",
  },
  {
    q: "Why hire WordPress developers in India?",
    a: "India offers cost-effective solutions with skilled developers who can build responsive, secure, and SEO-optimized websites tailored to your specific needs.",
  },
];
